import { COLORS } from 'constants/colors'
import styled, { css } from 'styled-components'

export const Header = styled.div`
  padding: 18px 15px 8px;
  border-bottom: 1px solid #ebebeb;
`

export const Title = styled.p`
  font-weight: 500;
  font-size: 14px;
  line-height: 1.4;
  color: ${COLORS.text.default};

  margin-bottom: 8px;
`

export const WeekDaysRow = styled.div`
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  grid-column-gap: 30px;
  justify-items: center;
  padding: 0px 8px;
`

export const WeekDay = styled.p`
  font-size: 12px;
  line-height: 1.3;
  color: #696b7b;
`

export const MainWrapper = styled.div`
  height: 300px;
  overflow: auto;
  padding: 20px 0px;
`

export const MonthWrapper = styled.div`
  &:not(:last-child) {
    margin-bottom: 14px;
  }
`

export const DaysWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  grid-column-gap: 0px;
  grid-row-gap: 10px;
  justify-items: center;
  align-items: center;
  padding: 12px 8px;

  border-top: 1px solid #ebebeb;
`

export const Day = styled.p`
  font-size: 14px;
  line-height: 1.3;
  color: ${COLORS.text.default};
  text-align: center;

  transition: all 0.2s;
`

export const DayWrapper = styled.div<{ start?: boolean; end?: boolean; between?: boolean; selected?: boolean }>`
  width: 28px;
  height: 28px;
  display: flex;
  justify-content: center;
  align-items: center;

  cursor: pointer;

  &:hover > ${Day} {
    color: ${COLORS.primary.medium};
  }

  ${({ start, end, between, selected }) => {
    return (
      (start || end || between || selected) &&
      css`
        background-color: ${COLORS.primary.medium};
        border-radius: 50%;

        & > ${Day}, &:hover > ${Day} {
          font-weight: 500;
          color: #ffffff;
        }
      `
    )
  }}

  ${({ between }) => {
    return (
      between &&
      css`
        width: 100%;
        border-radius: 0;
      `
    )
  }}

  ${({ end }) => {
    return (
      end &&
      css`
        width: 100%;
        border-radius: 0 14px 14px 0;
      `
    )
  }}
  
  ${({ start }) => {
    return (
      start &&
      css`
        width: 100%;
        border-radius: 14px 0 0 14px;
      `
    )
  }}
`
